/**
 * @Author: v_jppjpeng
 * @Date: 2024-09-29 16:07:57
 * @Explain: 占位符管理
 */

// type
import { PlaceholderTypeEnum } from '@/pages/placeholderManage/data.d';

// 默认暂停占位符 - 数据
export const defaultPausePlaceholderData = {
  // 资源码名称
  name: '',
  // 资源码ID
  id: 0,
  // 资源码类型 (默认固定类型)
  type: PlaceholderTypeEnum.FIXED,
};

export interface PlaceholderManageState {
  /** 暂停占位符 - 数据 */
  pausePlaceholderData: {
    name: string; // 资源码名称
    id: number; // 资源码ID
    type: number; // 资源码类型
  };
}

export type ModelType = {
  namespace: string;
  state: PlaceholderManageState;
  reducers: {
    setPausePlaceholderData: (
      state: PlaceholderManageState,
      action: { payload: any },
    ) => any;
    resetPausePlaceholderData: (state: PlaceholderManageState) => any;
  };
};

const PlaceholderManageModel: ModelType = {
  namespace: 'PlaceholderManageModel',
  state: {
    pausePlaceholderData: { ...defaultPausePlaceholderData },
  },
  reducers: {
    // 更新暂停占位符数据
    setPausePlaceholderData(state, action) {
      return {
        ...state,
        pausePlaceholderData: action.payload,
      };
    },
    // 重置暂停占位符数据
    resetPausePlaceholderData(state) {
      return {
        ...state,
        pausePlaceholderData: { ...defaultPausePlaceholderData },
      };
    },
  },
};

export default PlaceholderManageModel;
